import React from 'react';
import NavActivites from '../navactivities/navactivities';
import Header from '../../../header/header';
import Footer from '../../../footer/footer';

const Fitdance = (props) => {

  return (
    <div>
    <Header />
  <div id="stage">
    <div className="container">
        <div className="section-title">
        <NavActivites />
          <h2>Fitdance</h2>
          <br></br>
          <p>
          Le fitdance est une forme de danse qui combine des éléments de fitness et de danse chorégraphiée. <br></br>
          C’est une activité dynamique qui permet de se dépenser tout en s’amusant.</p>
        </div>
   <video className='img-responsive' controls src="../img/activites/fitdance/DSC_0681.MOV" />
  
<br></br>
<div className="stage-text">
<p><br></br> Les cours de fitdance sont généralement basés sur des mouvements de danse inspirés de divers styles, tels que la danse latine, le hip-hop ou même la danse contemporaine.</p>
  <br></br>
<h4>Les avantages du fitdance incluent :</h4>

<ul>
<p><li>Cardio : C'est un excellent moyen d'améliorer son endurance cardiovasculaire.</li></p>
<p><li>Coordination : Les mouvements de danse aident à développer la coordination et l'agilité..</li></p>
<p><li>Socialisation : C'est souvent pratiqué en groupe, ce qui favorise l'interaction et la convivialité.</li></p>
<p><li>Évacuation du stress : La danse est un excellent moyen de relâcher la pression et de se divertir.</li></p>
</ul>
<br></br>
<p>Le fitdance est accessible à tous, quel que soit le niveau de danse ou de fitness</p>

 
               </div>
</div>
      </div>
      < Footer />

    </div>

  );
};
export default Fitdance;